
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "141px",
    "height": "124px"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "fill-rule": "evenodd",
        "fill": "rgb(213, 202, 209)",
        "d": "M139.487,112.815 L76.050,3.906 C74.889,1.913 72.742,0.685 70.421,0.685 C68.099,0.685 65.953,1.913 64.793,3.906 L1.038,113.358 C-0.123,115.350 -0.123,117.805 1.038,119.800 C2.199,121.792 4.345,123.021 6.666,123.021 L134.175,123.021 C134.188,123.021 134.202,123.021 134.213,123.021 C137.804,123.021 140.712,120.136 140.712,116.579 C140.712,115.173 140.255,113.876 139.487,112.815 ZM17.923,110.137 L70.421,20.012 L122.919,110.137 L17.923,110.137 L17.923,110.137 ZM67.067,41.771 L73.810,41.771 C74.363,41.771 74.894,41.992 75.282,42.386 C75.669,42.782 75.879,43.311 75.864,43.862 L74.508,86.033 C74.479,87.140 73.565,88.019 72.452,88.019 L68.426,88.019 C67.311,88.019 66.397,87.137 66.370,86.033 L65.015,43.862 C65.000,43.311 65.210,42.782 65.596,42.386 C65.982,41.992 66.514,41.771 67.067,41.771 ZM75.778,93.617 L75.778,101.250 C75.778,102.376 74.860,103.289 73.721,103.289 L67.158,103.289 C66.021,103.289 65.103,102.376 65.103,101.250 L65.103,93.617 C65.103,92.493 66.021,91.580 67.158,91.580 L73.721,91.580 C74.860,91.577 75.778,92.493 75.778,93.617 Z"
      }
    }
  ]
})
    }
  